import { sendReport } from "../saveLoadData";
import { fillTeethList } from "../controls/TeethListManager";
import {
  getGeometryFromStl,
  getGeometryFromGlb,
} from "@/components/geometry/geometryLoader.js";
import {
  getIsMaxillaTooth,
  updateToothDentition,
} from "@/components/appStart/adjustModel";
import { simplifyGeometry } from "@/components/geometry/geometry.js";
import { loadStitchedTeeth } from "@/components/appStart/stitching";
import {
  loadDicomUrls,
  loadDicoms,
  updateAppLayout,
} from "@/components/dicom/DicomManager.js";
import { mutationTypes } from "@/store/modules/dicom";
import store from "@/store";

async function checkHasDicom() {
  let dicomZipUrl = vueApp.dicomZipUrl
    ? vueApp.dicomZipUrl
    : vueApp.dicomZipFromJson;
  try {
    console.log("checkHasDicom", dicomZipUrl, new Date());
    if (!dicomZipUrl) {
      let baseUrl = vueApp.zipFile ? vueApp.zipFile : vueApp.jsonLocation;
      let arr = baseUrl.split("/");
      arr.pop();
      const index = arr.indexOf("STL");
      arr.splice(index, 1);
      arr.push("dicom.zip");
      dicomZipUrl = arr.join("/");
    }
    let response = await fetch(dicomZipUrl, { method: "HEAD" });
    if (response.status === 200) {
      vueApp.hasDicom = true;
    }
  } catch (error) {
    console.log("there is no dicom.zip", dicomZipUrl);
  }
}

async function checkHasFullBones() {
  let fullBonesStls = ["mandibula_full.stl", "maxilla_full.stl"];
  try {
    console.log("checkHasFullBones", vueApp.stlBaseUrl);
    if (vueApp.stlBaseUrl) {
      for (const stlFile of fullBonesStls) {
        let stlUrl = `${vueApp.stlBaseUrl}/${stlFile}`;
        let response = await fetch(stlUrl, { method: "HEAD" });
        if (response.status === 200) {
          vueApp.hasFullBones = true;
          break;
        }
      }
    }
  } catch (error) {
    console.log("checkHasFullBones error", error);
  }
  return vueApp.hasFullBones;
}

async function loadDicomApp() {
  console.log("loadDicomApp");
  if (!vueApp.dicomZipUrl) await loadDicomUrls();

  if (vueApp.dicomLowLink) {
    vueApp.dicomZipUrl = vueApp.dicomLowLink;
    store.commit(mutationTypes.isLowQualityChange, true);
  }

  await loadDicoms(() => {
    updateAppLayout();
  });

  $(".dicom-on-item").css({ display: "block" });
  $(".dicom-off-item").css({ display: "none" });
  store.commit(mutationTypes.isAxialChange, true);
  store.commit(mutationTypes.isSaggitalChange, true);
  store.commit(mutationTypes.isCoronalChange, true);
  $(".dicom-container").css({ display: "block" });
  updateAppLayout();

  vueApp.switchDicom3dView();
}

async function loadJsZip(zipPath, showProgress) {
  let zip = null;
  if (zipPath) {
    zip = await loadJsZipFromCache(zipPath, showProgress);
    if (!zip) {
      zip = await loadJsZipFromWeb(zipPath, showProgress);
    }
  }
  return zip;
}

async function loadStlModels(stageModels) {
  // console.log("loadStlModels");
  let zip = null;
  let fromCache = false;

  // vueApp.zipFile = "/demo/mobile.zip";
  if (vueApp.zipFile) {
    zip = await loadJsZipFromCache(vueApp.zipFile);
    if (!zip) {
      zip = await loadJsZipFromWeb(vueApp.zipFile, true);
    } else {
      fromCache = true;
    }
  }

  let stlModels = [];
  if (zip) {
    vueApp.isGlb = !!zip.isGlb;
    stlModels = await processZip(zip, stageModels);
    if (stageModels && stlModels) {
      let stlModelsIds = stlModels.map((m) => m.id);
      stageModels = stageModels.filter((m) => !stlModelsIds.includes(m.id));
      stlModels = stlModels.concat(stageModels);
    }

    if (vueApp.isStitched && stlModels) {
      await loadStitchedTeeth();
    }
  }
  if (stlModels && stlModels.length) initViewer(stlModels);
}

async function loadJsZipFromCache(zipPath) {
  let zip = null;
  let stlZipPath = zipPath;
  let glbZipPath = stlZipPath
    ? stlZipPath.replace(new RegExp(".zip$"), ".glb.zip")
    : stlZipPath;
  try {
    if (vueApp.cache) {
      // vueApp.clearCache = false;
      if (vueApp.clearCache) {
        vueApp.cache.delete(stlZipPath).then((response) => {
          console.log(`delete cache ${stlZipPath}`, response);
        });
        vueApp.cache.delete(glbZipPath).then((response) => {
          console.log(`delete cache ${glbZipPath}`, response);
        });
      } else {
        let glbCache = await vueApp.cache.match(glbZipPath);
        let stlCache = await vueApp.cache.match(stlZipPath);
        let zipCache = glbCache ? glbCache : stlCache;
        if (zipCache) {
          let zipBlob = await zipCache.blob();
          zip = await JSZip.loadAsync(zipBlob);
          zip.isGlb = !!glbCache;
        }
      }
    }
    if (zip) {
      console.log("loadJsZipFromCache success");
    }
  } catch (error) {
    console.log("loadJsZipFromCache ERROR", error);
    try {
      vueApp.cache.delete(stlZipPath).then((response) => {
        console.log(`delete cache ${stlZipPath}`, response);
      });
      vueApp.cache.delete(glbZipPath).then((response) => {
        console.log(`delete cache ${glbZipPath}`, response);
      });
    } catch (error) {
      console.log("loadJsZipFromCache inner ERROR", error);
    }
  }
  return zip;
}

async function loadJsZipFromWeb(zipPath, showProgress) {
  let zip = null;
  try {
    let stlZipPath = zipPath;
    try {
      let glbZipPath = stlZipPath.replace(new RegExp(".zip$"), ".glb.zip");
      zip = await downloadZip(glbZipPath, true, showProgress);
    } catch (error) {
      console.log("loadJsZipFromWeb GLB ERROR", error);
    }

    if (zip == null || !zip.files || Object.entries(zip.files).length < 2) {
      zip = await downloadZip(stlZipPath, false, showProgress);
    } else {
      zip.isGlb = true;
    }

    if (zip) {
      console.log("loadJsZipFromWeb success");
    }
  } catch (error) {
    console.log("loadJsZipFromWeb ERROR", error);
  }
  return zip;
}

function downloadZip(zipPath, isGlb, showProgress) {
  let firstProgress = true;
  let downloadPath = `${zipPath}?updated=${new Date().getTime()}`;
  let promise = new JSZip.external.Promise(function (resolve, reject) {
    JSZipUtils.getBinaryContent(downloadPath, {
      progress: function (event) {
        if (showProgress) {
          if (firstProgress) {
            $("#loaderText").css("margin-left", "10px");
            firstProgress = false;
          }
          let percent = Math.ceil(event.percent * 0.75);
          $("#loaderText").html(`${percent} %`);
        }
        //stlLogMessage(event.percent + "% of " + event.path + " loaded");
      },
      callback: function (err, data) {
        stlLogMessage(`${new Date()} zip downloaded`);
        if (err) {
          if (!isGlb) {
            showLoadError();
            sendReport(`Load zip error. Zip URL:  ${zipPath}`);
          }
          reject(err);
        } else {
          if (showProgress) {
            $("#loaderText2").html(`Loading files...`);
            $("#loaderText3").html(`just a few more seconds`);
          }
          stlLogMessage(`zip downloaded, ${zipPath}`);
          const response = new Response(data);
          vueApp.cache.put(zipPath, response);
          if (vueApp.desktopStampName && vueApp.desktopZipTimeStamp) {
            localStorage.setItem(
              vueApp.desktopStampName,
              vueApp.desktopZipTimeStamp,
            );
          }
          resolve(JSZip.loadAsync(data));
        }
      },
    });
  });
  // if (callback) {
  //   promise
  //     // .then(JSZip.loadAsync)
  //     .then(function (zip) {
  //       callback(zip);
  //     })
  //     .then(
  //       function success(text) {
  //         stlLogMessage("Download zip success");
  //       },
  //       function error(e) {
  //         callback(null);
  //         if (!isGlb) {
  //           let message = `Download zip error. Zip URL: ${zipPath}. ${e}`;
  //           sendReport(message);
  //         }
  //       }
  //     );
  // }
  return promise;
}

async function processZip(zip, stageModels) {
  let models = [];
  if (zip) {
    let filesCount = Object.entries(zip.files).length;
    // console.log("processGlbZip filesCount", filesCount);
    if (filesCount == 0) {
      showLoadError();
      return;
    }

    for (let [filename, file] of Object.entries(zip.files)) {
      if (filename.startsWith("tooth_")) {
        let existedTooth = vueApp.allTeeth.find((x) => x.filename === filename);
        if (!existedTooth) {
          filename = filename.replace(".glb", ".stl");
          existedTooth = vueApp.allTeeth.find((x) => x.filename === filename);
        }
        if (!existedTooth) {
          let modelName = filename
            .replace("tooth_", "")
            .replace(".stl", "")
            .replace(".glb", "");

          let item = {
            name: modelName,
            filename: filename,
          };
          const parsed = parseInt(modelName, 10);
          if (parsed) {
            item.number = parsed;
          } else {
            console.error(`invalid tooth filename: ${filename}`);
            continue;
          }
          item.savedNumber = item.number;
          item.isTooth = true;
          item.isVisible = true;
          item.color = vueApp.teethColor;
          item.opacity = vueApp.teethOpacity;

          updateToothDentition(item);
          vueApp.addTooth(item);
          existedTooth = item;
        }
        existedTooth.savedFileName = existedTooth.filename = filename.replace(
          ".glb",
          ".stl",
        );
        let toothName = existedTooth.name;
        if (toothName.includes("_")) {
          const undescoreIndex = toothName.lastIndexOf("_");
          existedTooth.remarks = toothName.substring(undescoreIndex + 1);
        } else if (toothName.includes("-")) {
          const dashIndex = toothName.lastIndexOf("-");
          existedTooth.remarks = toothName.substring(dashIndex + 1);
        }
      }
    }

    const allItems = vueApp.allItems;
    const allIds = allItems.map(function (item) {
      return item.id ? item.id : 0;
    });
    const maxId = Math.max.apply(null, allIds);

    let i = maxId + 1;
    vueApp.allItems.forEach((item) => {
      if (!item.id) {
        // console.log("new item in zip", item);
        item.id = i++;
      }
      if (!item.isVisible) Vue.set(item, "isVisible", true);
    });

    let totalCount = allItems.length;
    let errorsExist = false;
    for (const item of allItems) {
      let fileName = item.filename;
      if (!isFalsyOrSpaces(fileName)) {
        let zipFile = zip.file(fileName);
        if (!zipFile) {
          fileName = fileName.replace(new RegExp(".stl$"), ".glb");
          zipFile = zip.file(fileName);
        }
        if (zipFile) {
          let loadedItem = allItems.find(
            (x) => x != item && x.filename === item.filename && x.fileLoaded,
          );
          if (loadedItem) {
            console.log(`file already loaded: ${fileName}`);
            vueApp.removeItem(item);
          } else {
            item.fileLoaded = true;
            let buffer = await zipFile.async("arraybuffer");
            let elementGeometry = zip.isGlb
              ? await getGeometryFromGlb(buffer)
              : getGeometryFromStl(buffer);
            if (!elementGeometry) {
              console.log(`Invalid file geometry ${fileName}`);
              vueApp.removeItem(item);
            } else {
              elementGeometry.computeBoundingBox();
              let phongMaterial = new THREE.MeshPhongMaterial({
                color: 0xeaeff2,
                flatShading: false,
                specular: 0x050505,
                shininess: 100,
                side: 2,
              });

              if (!vueApp.isHighQuality) {
                simplifyGeometry(elementGeometry, vueApp.simplifyPercent);
              }

              let tmesh = new THREE.Mesh(elementGeometry, phongMaterial);
              tmesh.filename = fileName;
              let model = {
                id: item.id,
                mesh: tmesh,
                color: item.color,
                opacity: item.opacity,
                isTooth: item.isTooth,
                isBone: item.isBone,
              };
              models.push(model);

              if (item.isTooth) {
                vueApp.toothModels.push({
                  id: item.id,
                  mesh: new THREE.Mesh(
                    elementGeometry.clone(),
                    phongMaterial.clone(),
                  ),
                  color: item.color,
                });
              }

              if (item.isBone) {
                tmesh.defaultGeometry = elementGeometry;
                let solidGeometry = await getSolidBoneGeometry(zip, fileName);
                if (solidGeometry) {
                  tmesh.solidGeometry = solidGeometry;
                  vueApp.hasSolidBones = true;
                }
                let closedGeometry = await getClosedBoneGeometry(zip, fileName);
                if (closedGeometry) {
                  tmesh.closedGeometry = closedGeometry;
                  vueApp.hasClosedBones = true;
                }
              }
            }

            let startPoint = 75; // fromCache ? 1 : 75;
            let coef = 5; // fromCache ? 79 : 5;
            let percent = Math.floor(
              startPoint + (models.length * coef) / totalCount,
            );
            stlLogMessage(
              `${new Date()} item unzipped ${fileName}, ${percent}%`,
            );
            $("#loaderText").html(`${percent} %`);
          }
        } else {
          let stageModel = stageModels
            ? stageModels.find((m) => m.id == item.id)
            : null;
          if (!stageModel) {
            if (
              vueApp.gingivae.indexOf(item) < 0 &&
              vueApp.airways.indexOf(item) < 0
            ) {
              errorsExist = true;
              sendReport(`Can't find file in zip with name ${fileName}`);
            }
            vueApp.removeItem(item);
          }
        }
      }
    }

    stlLogMessage(`${new Date()} archive unzipped`);
    $("#loaderText").html(`80 %`);

    setTimeout(function () {
      fillTeethList();
    }, 50);

    if (errorsExist) {
      vueApp.savedData.clearCache = true;
    }
  }
  return models;
}

function showLoadError() {
  $(".menu3d").css({ display: "none" });
  $("#loaderImage").css({ display: "none" });
  $("#loaderText").css("margin-left", "0");
  $("#loaderText").html(`Load case error. Please contact support@cephx.com`);
  $("#loaderText2").html(``);
  $("#loaderText3").html(``);
}

async function getClosedBoneGeometry(zip, fileName) {
  let cgeometry = null;
  try {
    fileName = fileName
      .replace("mandibula", "mandibula_closed")
      .replace("maxilla", "maxilla_closed");

    let zipFile = zip.file(fileName);
    if (zipFile) {
      let buffer = await zipFile.async("arraybuffer");
      cgeometry = zip.isGlb
        ? await getGeometryFromGlb(buffer)
        : getGeometryFromStl(buffer);

      let matrix2 = new THREE.Matrix4();
      matrix2.makeRotationAxis(new THREE.Vector3(0, 1, 0), rotateY);
      cgeometry.applyMatrix4(matrix2);

      let matrix1 = new THREE.Matrix4();
      matrix1.makeRotationAxis(new THREE.Vector3(1, 0, 0), rotateX);
      cgeometry.applyMatrix4(matrix1);

      cgeometry = new THREE.Geometry().fromBufferGeometry(cgeometry);
      // cgeometry.mergeVertices();
      cgeometry.computeVertexNormals();
      cgeometry = new THREE.BufferGeometry().fromGeometry(cgeometry);
      cgeometry.computeBoundingBox();

      let box = offsetBox(cgeometry.boundingBox);
      cgeometry.baseBox = box;
      cgeometry.center();
    }
  } catch (error) {
    console.log("getClosedBoneGeometry ERROR: ", error);
  }
  return cgeometry;
}

async function getSolidBoneGeometry(zip, fileName) {
  console.log("getSolidBoneGeometry", fileName);
  let cgeometry = null;
  try {
    fileName = fileName
      .replace("mandibula", "mandibula_solid")
      .replace("maxilla", "maxilla_solid");

    let zipFile = zip.file(fileName);
    if (zipFile) {
      let buffer = await zipFile.async("arraybuffer");
      cgeometry = zip.isGlb
        ? await getGeometryFromGlb(buffer)
        : getGeometryFromStl(buffer);

      let matrix2 = new THREE.Matrix4();
      matrix2.makeRotationAxis(new THREE.Vector3(0, 1, 0), rotateY);
      cgeometry.applyMatrix4(matrix2);

      let matrix1 = new THREE.Matrix4();
      matrix1.makeRotationAxis(new THREE.Vector3(1, 0, 0), rotateX);
      cgeometry.applyMatrix4(matrix1);

      cgeometry = new THREE.Geometry().fromBufferGeometry(cgeometry);
      // cgeometry.mergeVertices();
      cgeometry.computeVertexNormals();
      cgeometry = new THREE.BufferGeometry().fromGeometry(cgeometry);
      cgeometry.computeBoundingBox();

      let box = offsetBox(cgeometry.boundingBox);
      cgeometry.baseBox = box;
      cgeometry.center();
    }
  } catch (error) {
    console.log("getSolidBoneGeometry ERROR: ", error);
  }
  return cgeometry;
}

export {
  loadStlModels,
  showLoadError,
  loadJsZipFromCache,
  loadJsZipFromWeb,
  loadJsZip,
  checkHasDicom,
  loadDicomApp,
  checkHasFullBones,
};
